import {UnathorizedError} from "../exceptions/UnathorizedError";
import {getRequest, postRequest} from "./AxiosConfig";

export const baseURL = process.env.REACT_APP_KARAKTERBOOST_API_URL;

async function getTest(test_id) {
    return await getJSON("api/test/find/" + test_id);
}

async function getAssembledTest(test_id) {
    return await getJSON("api/test/assemble/" + test_id);
}

export async function getAssembledQuizByName(name, setErrorMessage) {
    return await getRequest(`/test/assemble/name/${name}`, setErrorMessage);
}

async function getCourse(courseId) {
    return await getJSON("course?course_id=" + courseId);

}

async function getVideo(videoId) {
    return await getJSON("lesson/video?video_id=" + videoId);

}

async function getProducts(pageSize = 10, page = 0, type = "") {
    return await getJSON("products?type=" + type + "&page=" + page + "&pageSize=" + pageSize);
}


async function deliverTest(courseId, testId, answers, setErrorMessage) {


    return await postRequest("test/grade_quiz", setErrorMessage, {
        courseId: courseId,
        testId: testId,
        answers: answers.map(item => {
            return {
                questionId: item.question.id,
                answers: item.answers.map(answer => answer.id)
            }
        })

    })

}

async function getMedia() {
    return await getJSON("admin/media");
}

export async function getJSON(url, productId = 5) {
    let json = null;

    let response = await fetch(baseURL + url, {
        method: "GET",
        withCredentials: "true",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "X-PRODUCT-ID":productId,
            "X-TOKEN_TYPE":"QUIZ"
        }
    });

    if(response.ok) {
        json = await response.json().catch(err => console.log("JSON : ", baseURL + url))

    } else {
        switch (response.status) {
            case 403:
            case 401:
                console.log("Unauthorized")
                throw UnathorizedError("Uautorisert tilgang")

        }
    }


    return json;
}

export async function uploadFile(file, alt, description, setErrorMessage) {
    let formData = new FormData();


    formData.append('file', file);
    formData.append('description', description);
    formData.append('alt', alt);

    return postRequest("/media/upload", setErrorMessage, formData);
}


async function saveVideo(data) {
    let response = await fetch(baseURL + "admin/video/save", {
        withCredentials: "true",
        credentials: "include",
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data),
        method: "POST"
    });

}


async function postData(path, data) {
    let error = null;
    let response = await fetch(baseURL + path, {
        withCredentials: "true",
        credentials: "include",
        headers: {
            'Content-Type': 'application/json',
        },
        method: "POST",
        body: JSON.stringify(data),
    }).catch(e => console.log(e.message));

        return response.json();
}



export {
    deliverTest,
    getTest,
    getAssembledTest,
    getProducts,
    getMedia,
    getVideo,
    getCourse,
    saveVideo,
    postData
};